<template>
  <div :class="['article', post.acf_preview.class]" v-if="$root.dataReady">
    <header class="heading">
      <div class="container">
        <div class="text">
          <div class="sub-title">
            <div class="type news" v-if="post.categories">{{post.categories[0].name}}</div>
            <div class="date">{{formatDate(post.date)}}</div>
          </div>
          <h2 class="h2--smaller">{{removeAccents(post.title.rendered)}}</h2>
        </div>
      </div>
    </header>
    <div class="container">
      <div class="post-content">
        <div class="post-image" v-if="post.featured_image">
          <img :src="post.featured_image" alt />
        </div>
        <div v-html="post.content.rendered"></div>

        <div class="main-content">
          <template>
            <template v-for="(block, index) in blocks">
              <component :is="block.acf_fc_layout" :key="index" :blockdata="block"></component>
            </template>
          </template>
        </div>
      </div>
    </div>
    <div class="bottom-socials">
      <ul class="socials-light opacity-full">
        <li>
          <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + post.link">
            <div class="fb-grey-icon"></div>
          </a>
        </li>
        <li>
          <a :href="'https://twitter.com/home?status=' + post.link">
            <div class="tw-grey-icon"></div>
          </a>
        </li>
        <li>
          <a :href="'https://www.linkedin.com/shareArticle?mini=true&url=' + post.link">
            <div class="in-grey-icon"></div>
          </a>
        </li>
      </ul>
    </div>
    <div class="related-news" v-if="relatednewsids">
      <h2>Related News</h2>
      <div class="posts">
        <div class="container">
          <div class="content">
            <div class="row no-margin wrapper">
              <div
                class="row-element col-l-6 col-m-12 col-s-12"
                v-for="(post, index) in relatednews"
                v-if="index < posttoshow"
                :key="index"
              >
                <router-link
                  tag="a"
                  class="post small"
                  :to="{path: '/'+ post.pure_taxonomies.categories[0].slug +'/' + post.slug}"
                >
                  <div class="row no-margin">
                    <div class="image row-element col-l-6 col-m-6 col-s-12">
                      <div
                        class="bg"
                        :style="{ 'background-image': 'url( '+ post.better_featured_image.source_url+ ' )'}"
                      ></div>
                    </div>
                    <div class="row-element col-l-6 col-m-6 col-s-12">
                      <div class="text">
                        <div class="sub-title">
                          <div
                            :class="['type', post.pure_taxonomies.categories[0].category_nicename]"
                          >{{post.pure_taxonomies.categories[0].name}}</div>
                          <div class="date">{{formatDate(post.date)}}</div>
                        </div>
                        <div class="title">{{post.title.rendered}}</div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="button" v-if="showmorebtn">
          <a v-on:click="showMore()" class="btn default">show me more</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Block from "../components/Block.vue";
import OurWorkSlider from "../components/OurWorkSlider.vue";
import ChangeSection from "../components/ChangeSection.vue";
import BlockMap from "../components/BlockMap.vue";
import ImageWrapper from "../components/ImageWrapper.vue";
import OurPeopleSlider from "../components/OurPeopleSlider.vue";
import VideoWrapper from "../components/VideoWrapper.vue";
import BlockCmgGreenhouse from "../components/BlockCmgGreenhouse.vue";

export default {
    name: "post-preview",
    data() {
        return {
            blocks: null,
            post: null,
            relatednewsids: null,
            relatednews: [],
            posttoshow: 2,
            showmorebtn: true
        };
    },
    components: {
        Block,
        OurWorkSlider,
        ChangeSection,
        BlockMap,
        ImageWrapper,
        OurPeopleSlider,
        VideoWrapper,
        BlockCmgGreenhouse
    },
    created: function() {
        this.$root.headeriswhite = false;
        this.$root.dataReady = false;
        this.fetchData();
    },
    methods: {
        fetchData: function() {
            var self = this;

            if(!this.$route.params.preview_key || !this.$route.params.id) {
              self.$router.push({ name: "page-not-found" });
            } else {
              $.get(
                self.$root.apiUrl + "wp-json/wp/v2/posts/" + this.$route.params.id + "/preview?preview_key=" + this.$route.params.preview_key,
                function (response) {
                  if (!response) {
                    self.$router.push({name: "page-not-found"});
                  } else {
                    self.post = response;
                    self.blocks = response.acf_preview.block_grid;
                    self.relatednewsids = response.acf_preview.related_news;
                    self.setTitle(response.title.rendered);
                    if (self.relatednewsids) {
                      self.relatednewsids.map(function (id) {
                        $.get(
                          self.$root.apiUrl +
                          "wp-json/wp/v2/posts/" +
                          id,
                          function (response) {
                            self.relatednews.push(response);
                          }
                        )
                          .done(function () {
                          })
                          .fail(function () {
                          });
                      });
                    }
                    self.$root.dataReady = true;
                  }
                }
              )
                .done(function () {
                  if (self.relatednewsids.length - 1 < self.posttoshow) {
                    self.showmorebtn = false;
                  } else {
                    self.showmorebtn = true;
                  }
                })
                .fail(function () {
                  self.$router.push({name: "page-not-found"});
                });
            }
        },
        formatDate: function(date) {
            var mydate = new Date(date);
            var month = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ][mydate.getMonth()];
            return month + " " + mydate.getDate() + ", " + mydate.getFullYear();
        },
        removeAccents: function(title) {
            return title.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        },
        showMore: function() {
            if (this.relatednews.length - 1 <= this.posttoshow) {
                this.showmorebtn = false;
                this.posttoshow += 2;
            } else {
                this.showmorebtn = true;
                this.posttoshow += 2;
            }
        },
        setTitle: function(title) {
            title = title.normalize('NFD').replace("&#038;", "&");
            document.title = title + " - Weber Shandwick";
        }
    }
};
</script>



// WEBPACK FOOTER //
// PostPreview.vue?01cb7c0f